import { notify } from 'notify';
import { createApp } from 'vue';

import { create_store } from '../jobs-app/_store.js';

/**
 * Reads a JSON app config from an element's `data-config` attribute.
 *
 * @param {Element} app_el
 * @return {Object}
 */
export function read_app_config(app_el) {
	let config = {};

	try {
		config = JSON.parse(app_el.dataset.config) || {};
	} catch (error) {
		notify(`error`, error);
	}

	return config;
}

/**
 * Mounts a Vue app, initialising the shared jobs/ideas store when `store` data
 * is supplied. `load` returns `{ component, props, store }`.
 *
 * @param {Element} app_el
 * @param {Function} load
 */
export async function mount_vue_app(app_el, load) {
	try {
		const { component, props = {}, store } = await load();

		if (store) {
			create_store(store);
		}

		createApp(component, props).mount(app_el);
	} catch (error) {
		notify(`error`, error);
	}
}

/**
 * Requests the external Jobs API and resolves the parsed JSON body.
 *
 * Mirrors _rest.js but targets the `${api_url}/api/...` host rather than the
 * WP `sh/v1` namespace.
 *
 * @param {string} api_url
 * @param {string} path
 * @param {Object} [options]
 * @return {Promise}
 */
export function fetch_app_data(api_url, path, options = {}) {
	const fetch_options = {
		method: options.method || `GET`,
		credentials: `same-origin`,
		headers: {
			'Content-Type': `application/json`,
		},
	};

	if (options.signal) {
		fetch_options.signal = options.signal;
	}

	if (options.body) {
		fetch_options.body = JSON.stringify(options.body);
	}

	return fetch(`${api_url}${path}`, fetch_options).then((response) => {
		if (!response.ok) {
			throw new Error(`Network response was not ok`);
		}

		return response.json();
	});
}
